export const ORDERS_PAGE_SIZE = 10;
export const WAREHOUSE_RELEASES_PAGE_SIZE = 25;
export const ORDER_SUPPLIERS_PAGE_SIZE = 5;
export const SPECIFICATIONS_PAGE_SIZE = 20;
